export const LongDescription = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 7H26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M6 13H20" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M6 19H26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M6 25H20" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
